import ConfirmCloseInvestmentDetails from "./ConfirmCloseInvestmentDetails";
import Modal from "components/Modal";

export default function ConfirmCloseInvestmentFixedDetails({
  open,
  onClose,
  data,
}) {
  return (
    <Modal
      maxWidth={"sm"}
      onClose={onClose}
      open={open}
      title="Close Investment Fixed"
      dir="ltr"
    >
      <ConfirmCloseInvestmentDetails
        data={data}
        onClose={onClose}
      />
    </Modal>
  );
}
